import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  Stack,
} from "@mui/material";
import { MediaModal } from "../../components/MediaModal";

export const Begrafenis = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleOpen = (image: string) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Box sx={{ textAlign: "center", mt: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Informatie over de begrafenis
      </Typography>

      <Typography variant="body1" paragraph>
        Hieronder vindt u de rouwbrief. Deze kan bekeken worden of als PDF
        gedownload worden.
      </Typography>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ mt: 2 }}
      >
        <Card
          sx={{
            width: { xs: "100%", md: "40%" },
            boxShadow: 2,
            cursor: "pointer",
          }}
          onClick={() => handleOpen("/images/rouwbrief-1.jpg")}
        >
          <CardMedia
            component="img"
            image="/images/rouwbrief-1.jpg"
            alt="Rouwbrief pagina 1"
          />
        </Card>

        <Card
          sx={{
            width: { xs: "100%", md: "40%" },
            boxShadow: 2,
            cursor: "pointer",
          }}
          onClick={() => handleOpen("/images/rouwbrief-2.jpg")}
        >
          <CardMedia
            component="img"
            image="/images/rouwbrief-2.jpg"
            alt="Rouwbrief pagina 2"
          />
        </Card>
      </Stack>

      <Box sx={{ mt: 4 }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#3c5875",
            color: "white",
            textTransform: "none",
            px: 3,
            py: 1.2,
            "&:hover": { backgroundColor: "#2c455a" },
          }}
          href="/pdfs/Erwin Van Brussel.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          📄 Download rouwbrief (PDF)
        </Button>
      </Box>

      <MediaModal open={open} media={selectedImage} onClose={handleClose} />
    </Box>
  );
};
